import { Route, Routes } from "react-router-dom"
import type { AppShell } from "@/App"
import { ProducaoProvider } from "./context"
import { MaterialProvider } from "./material"
import { AssignPanel } from "./AssignPanel"
import { Quadro } from "./Quadro"
import { Semana } from "./Semana"
import { Detalhe } from "./Detalhe"
import { Equipas } from "./Equipas"
import { Configuracoes } from "./Configuracoes"
import { VanFieldLog } from "./Campo"
import { ContractLink } from "./ContractLink"

/**
 * Área Produção (janela do gestor). Montada em `/producao/*` pelo App.
 * O painel de atribuição (G3) não tem rota: abre por cima de G1, G2 e G4.
 */
export function ProducaoArea({ shell }: { shell: AppShell | null }) {
  return (
    <ProducaoProvider shell={shell}>
      <MaterialProvider shell={shell}>
        <Routes>
          <Route index element={<Quadro />} />
          <Route path="semana" element={<Semana />} />
          <Route path="obras/:id" element={<Detalhe />} />
          <Route path="equipas" element={<Equipas />} />
          <Route path="configuracoes" element={<Configuracoes />} />
          <Route path="carrinhas" element={<VanFieldLog />} />
          {/* A mesma ligação que `/contracts/<id>` (App.tsx), dentro da área. */}
          <Route path="contracts/:contractId" element={<ContractLink shell={shell} />} />
          <Route path="*" element={<Quadro />} />
        </Routes>
        <AssignPanel />
      </MaterialProvider>
    </ProducaoProvider>
  )
}
